namespace TabAurous.Administration {
    export namespace APIKeysService {
        export const baseUrl = 'Administration/APIKeys';

        export declare function Create(request: Serenity.SaveRequest<APIKeysRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<APIKeysRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<APIKeysRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<APIKeysRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GenerateAPIKey(request: KeyRequest, onSuccess?: (response: Common.GetAPIKeyResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Administration/APIKeys/Create",
            Update = "Administration/APIKeys/Update",
            Delete = "Administration/APIKeys/Delete",
            Retrieve = "Administration/APIKeys/Retrieve",
            List = "Administration/APIKeys/List",
            GenerateAPIKey = "Administration/APIKeys/GenerateAPIKey"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GenerateAPIKey'
        ].forEach(x => {
            (<any>APIKeysService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
